import React, { ReactNode, useRef, useState } from "react"
import { useHistory } from "react-router"
import { useRecoilValue } from "recoil"
import { getListPharmacy, setCurrentPharmacy } from '../../api'
import { PharmacyModel } from "../../models/pharmacy"
import { accountDataState } from "../../recoil/account"
import { useAsync } from "../../utils"
import useClickOutside from "../../utils/hooks/useClickOutSide"
import { Header } from "../shared"
import Search, { useSearch } from "../shared/Search"

interface IProps {
    handleSelect?: (selectedPharmacy: PharmacyModel) => void;
    redirectLink?: string;
}

const SearchPharmacys = React.memo((
    props: IProps
) => {
    const {
        handleSelect,
        redirectLink
    } = props

    const history = useHistory()
    const searchRef: any = useRef()
    const search = useSearch()

    const getListPharmacyAsync = useAsync<Array<PharmacyModel>>(getListPharmacy)

    const accountInfo = useRecoilValue(accountDataState)
    const [state, setState] = useState<{
        skip: number,
        limit: number,
        listPharmacy: Array<PharmacyModel>,
        outOfData: boolean,
        show: boolean,
    }>({
        skip: 0,
        limit: 10,
        listPharmacy: [],
        outOfData: false,
        show: false,
    })


    useClickOutside(() => {
        setState(prev => ({ ...prev, show: false }))
    }, [searchRef])

    const resetState = () => {
        setState({
            skip: 0,
            limit: 10,
            listPharmacy: [],
            outOfData: false,
            show: false,
        })
    }

    const handleSeach = (value: string) => {
        if (value === '') {
            resetState()
            return
        }

        const params = {
            skip: state.skip,
            limit: state.limit,
            mName: value,
            adminId: accountInfo.doctor.mId
        }
        getListPharmacyAsync.execute(params).then(res => {
            setState(prev => ({
                ...prev,
                skip: 0,
                listPharmacy: res,
                show: true,
                outOfData: res.length === 0
            }))
        })
    }

    const onScrollHitBottom = () => {
        if (state.outOfData) return
        const params = {
            skip: state.skip + 10,
            limit: state.limit,
            mName: search.getValue(),
            adminId: accountInfo.doctor.mId
        }

        getListPharmacyAsync.execute(params).then(res => {
            setState(prev => ({
                ...prev,
                skip: prev.skip + 10,
                listPharmacy: [...prev.listPharmacy, ...res],
                outOfData: res.length < 10
            }))
        })
    }

    return <div className='w-100'>
        {/* <Header
            title="Tìm nhà thuốc"
            subTitle={`Admin ${accountInfo.doctor.mDisplayName}`}
            backTo="/"
            showSideBar
            disableBackTo
        /> */}
        <div id="main">
            <div className="container" ref={searchRef}>
                <Search
                    register={search}
                    onClear={resetState}
                    onSearch={handleSeach}
                    onScrollHitBottom={onScrollHitBottom}
                    data={state.listPharmacy}
                    loading={getListPharmacyAsync.status === "loading"}
                    dropdownData={(listPharmacy: Array<PharmacyModel>, onSelect: () => void) => {
                        return listPharmacy.map((pharmacy: PharmacyModel) => {
                            return <li onClick={() => {
                                if (redirectLink) {
                                    history.push(redirectLink)
                                }
                                setCurrentPharmacy({
                                    pharmacyCode: pharmacy.mPharCode,
                                    pharmacyId: pharmacy.mId,
                                    pharmacyData: pharmacy
                                })
                                resetState()
                                onSelect()
                                if (handleSelect) {
                                    handleSelect(pharmacy)
                                }
                            }} key={pharmacy.mId}>
                                <a>
                                    <strong>{pharmacy.mName}</strong><br />
                                    <small className="txt-gray">{pharmacy.mPharCode}</small>
                                </a>
                            </li>
                        })
                    }}
                />
            </div>
        </div>
    </div>
})

export default SearchPharmacys